import React from 'react'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import MomentUtils from "@date-io/moment";
import "moment/locale/es";
import './CustomDate.scss'

const CustomDate = ({ label, value, onChange }) => {

  return (
    <div className='customdate-container'>
      <label>{label}</label>
      {!value && <p>Seleccionar ...</p>}
      <MuiPickersUtilsProvider utils={MomentUtils} locale="es">
        <KeyboardDatePicker
          disableToolbar
          variant="inline"
          format="DD/MM/YYYY"
          margin="normal"
          id="date-picker-inline"
          value={value}
          autoOk
          onChange={onChange}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
      </MuiPickersUtilsProvider>
    </div>

  )

}

export default CustomDate
